import { render } from "./Salaries.vue?vue&type=template&id=7a02449a&scoped=true"
import script from "./Salaries.vue?vue&type=script&lang=js"
export * from "./Salaries.vue?vue&type=script&lang=js"

import "./Salaries.vue?vue&type=style&index=0&id=7a02449a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a02449a"]])

export default __exports__